export const API_URL = "https://qa-api.thesnuslife.com";
export const ENVIRONMENT = "development"
export const instId ="1476888";
export const currency = "GBP";
export const WEB_URL = "https://qa-frontend.thesnuslife.com"
export const GATEWAY_MARCHANT_ID = "BCR2DN4TX7WYBWDK" 
export const GATEWAY_ENTITY_ID = "8ac7a4c7932dbef001932f58a4c102c1" 
export const GATEWAY_SUCCESS_CODE = "000.100.110"